import { render, staticRenderFns } from "./Companies.view.vue?vue&type=template&id=4c89b0c0"
import script from "./Companies.view.vue?vue&type=script&lang=ts"
export * from "./Companies.view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports